/*
 * Define a form page asking the user if anyone can corroborate the report.
 */
import css from './pages.module.css'
import { yesNoPage } from './choicePage'

export const witnessCorroborationPage = propOverrides => {
  const props = {
    pageId: 'witness_corroboration_page',
    fieldName: 'witness_corroboration',
    label: 'Is there anyone else that can help corroborate your report?',
    className: css.choices,
    labelClassName: css.largeLabel,
    ...propOverrides
  }

  return yesNoPage({ ...props })
}
